
/* 
  Created by Hoàng Đức Thuận at 06-28-2022 15:42:22
  Module login
*/
import { ShopOutlined } from '@ant-design/icons';
import { PRODUCT_MANAGER_PATH } from 'constants/path';
import { lazy } from 'react';
import { IRoute } from 'types/Route';

const ManageGarageScreen = lazy(
    () => import('modules/product/product.screen')
);

const ContentLayout = lazy(
    () => import('../../libraries/layouts/content.layout')
);

const ManageGarageRoute: IRoute = {
    path: PRODUCT_MANAGER_PATH,
    name: 'product.menu',
    component: ContentLayout,
    icon: <ShopOutlined />,
    routes: [
        {
            path: PRODUCT_MANAGER_PATH,
            name: 'product.menu',
            component: ManageGarageScreen,
            exact: true
        },
    ]
};

export default ManageGarageRoute;

